/* eslint react/no-direct-mutation-state: "off", 'no-redeclare': 'off','no-dupe-keys':'off', 'no-loop-func':'off', eqeqeq: 'off' */
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Col, FormGroup, Label, Form } from 'reactstrap';
import { makeGetCall } from '../../../../action/tenantAction';
import DatePicker from 'react-datepicker';
import DatePickerCustom from '../../../common/DatePicker';
import Conversions from '../../../../Resources/Conversions';
import { Redirect } from 'react-router-dom';
import SearchableDropDown from './SearchableDropdown';
import SearchableEquipmentDropDown from './SearchableDropdown';
import SearchableSpaceDropDown from './FloorSpaceSearchableDropdown';
import AttachmentElement from './Attachment';
import moment from 'moment';
import classnames from 'classnames';
import { GetWorkOrderBuildings, GetWorkOrderBuildingsEquipments, GetWorkorderDetails, GetWorkorderTechnician, UpdateWorkOrder, GetBuildingAssociation, GetWorkOrderEquipments } from '../../../../action/workorderAction';
import "../../../../Assets/styles/customDatePickerWidth.css";
import {MdSave} from 'react-icons/md';
import ReactDOM from 'react-dom';  
import {Icon} from 'semantic-ui-react';
import { CheckBoxSelection, Inject, MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns';

const ErrorPadding ={
    color:'#D42D27',
    fontfamily:'Lato',
    fontSize:'13px',
    fontStyle:'italic',
    border:'2px solid #D42D27',
    height:'40px',
    padding:'10px',
    float:'left',
    marginTop:'0px',
    marginBottom:'5px'    
};
const ErrorSign ={
    color:'#D42D27',
    paddingLeft:'8px',
    paddingTop:'0px',
    paddingRight:'14px',
    width:'22px',
    height:'22px',
    top:'406px',
    left:'959px'
};
const CustomSelect = {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: "9999",
    width: "400px",
    maxHeight: "300px",
    overflowY: "auto",
    zIndex: "9999",
    border: "1px solid black",
    backgroundColor: "white",
    display: "none"
};

let g_CreatedDate = new Date(), IsSelectedBuildingExists = true;
class UpadteWorkOrder extends Component {

    componentWillMount() {
        let WorkOrderID = this.props.TaskId;
        this.props.makeGetCall();
        this.props.GetWorkorderDetails(WorkOrderID);
        this.props.GetWorkorderTechnician();
        this.props.GetWorkOrderEquipments();
        var IsWOForm = (this.props.getDetails.WorkOrderDetails.workOrderForm !== undefined && this.props.getDetails.WorkOrderDetails.workOrderForm !== null) ? this.props.getDetails.WorkOrderDetails.workOrderForm.isCustomerForm : false;
        const l_Request = this.props.GetWorkOrderBuildingsEquipments();
        l_Request.then((result) => {
            const unassigned = 'Choose one'
            var l_SiteId = this.props.getDetails.WorkOrderDetails.workOrderDetail.siteID;
            var l_FloorId = this.props.getDetails.WorkOrderDetails.workOrderDetail.floorID;
            var l_SpaceId = this.props.getDetails.WorkOrderDetails.workOrderDetail.spaceID;
            var l_Buildings = l_SiteId > 0 ? this.props.getWorkOrderBuildings.filter(el => el.id == l_SiteId)[0] : null;
            var l_BuildingDate = l_SiteId > 0 ? l_Buildings.buildingDate : "1753/01/01";
            var l_Floors = l_Buildings != null && l_FloorId > 0 ? l_Buildings.floors.filter(e => e.id == l_FloorId)[0] : null;
            var l_Rooms = l_FloorId > 0 ? l_Floors.spaces : l_SiteId > 0 ? l_Buildings.spaces : null;
            var l_ServerTime = this.props.getDetails.WorkOrderDetails.serverTime;
            var l_LogicalBuildingId = this.props.getDetails.WorkOrderDetails.workOrderDetail.logicalBuildingID;
            var l_TenantId = this.props.getDetails.WorkOrderDetails.workOrderDetail.tenantID;

            var TechnicianName = '', MailAddress = "", lNotifyOthers = [];
            if (this.props.getTechnicianList != undefined && this.props.getTechnicianList.length) {
                var TechName = this.props.getTechnicianList.filter(el => el.technicianID == this.props.getDetails.WorkOrderDetails.assignedUserID);
                TechnicianName = (TechName[0] !== undefined && TechName[0] !== null) ? TechName[0].name : '';
                MailAddress = (TechName[0] !== undefined && TechName[0] !== null) ? TechName[0].emailAddress : "";
            }

            if(this.props.getDetails.WorkOrderDetails.notifyUserIDs !== undefined && this.props.getDetails.WorkOrderDetails.notifyUserIDs.length){
               this.props.getDetails.WorkOrderDetails.notifyUserIDs.forEach(e => {
                    var TechMailAddress = this.props.getTechnicianList.filter(el => el.technicianID === e)[0].emailAddress;
                    if(TechMailAddress !== ''){
                        lNotifyOthers.push(e);
                    }
                })
            }

            var myDate = new Date(this.props.getDetails.WorkOrderDetails.dueDate)
            let utcOffsetMinute = moment().utcOffset();
            var fDate;
            if (utcOffsetMinute >= 0) {
                fDate = moment(moment.parseZone(myDate).format("YYYY-MM-DD")).add(utcOffsetMinute, 'minutes')
                l_BuildingDate = moment(moment.parseZone(l_BuildingDate).format("YYYY-MM-DD")).add(utcOffsetMinute, 'minutes')
                l_ServerTime = moment(moment.parseZone(l_ServerTime).format("YYYY-MM-DD")).add(utcOffsetMinute, 'minutes')
            }
            else {
                fDate = moment(moment.parseZone(myDate).format("YYYY-MM-DD")).subtract(utcOffsetMinute, 'minutes')
                l_BuildingDate =  moment(moment.parseZone(l_BuildingDate).format("YYYY-MM-DD")).subtract(utcOffsetMinute, 'minutes')
                l_ServerTime = moment(moment.parseZone(l_ServerTime).format("YYYY-MM-DD")).subtract(utcOffsetMinute, 'minutes')
            }

            this.setState({
                dueDate: this.props.getDetails.WorkOrderDetails.dueDate != '1753-01-01T00:00:00' ? new Date(fDate) : null,
                Status: (this.props.getDetails.WorkOrderDetails.status > 0) ? (this.props.getWorkorderPreferences.filter(x => x.field == this.props.getLabels['WorkOrderDetails.Status.Text']).length > 0) ? this.props.getWorkorderPreferences[0].value.filter(x => x.key == this.props.getDetails.WorkOrderDetails.status)[0].value : "Open - To be scheduled" : "Open - To be scheduled ",
                StatusId: (this.props.getDetails.WorkOrderDetails.status > 0) ? (this.props.getWorkorderPreferences.filter(x => x.field == this.props.getLabels['WorkOrderDetails.Status.Text']).length > 0) ? this.props.getWorkorderPreferences[0].value.filter(x => x.key == this.props.getDetails.WorkOrderDetails.status)[0].key : "1" : "1",
                Urgency: (this.props.getDetails.WorkOrderDetails.urgency > 0) ? (this.props.getWorkorderPreferences.filter(x => x.field == this.props.getLabels['WorkOrderDetails.Urgency.Text']).length > 0) ? this.props.getWorkorderPreferences[2].value.filter(x => x.key == this.props.getDetails.WorkOrderDetails.urgency)[0].value : "Low" : "--",
                UrgencyId: (this.props.getDetails.WorkOrderDetails.urgency > 0) ? (this.props.getWorkorderPreferences.filter(x => x.field == this.props.getLabels['WorkOrderDetails.Urgency.Text']).length > 0) ? this.props.getWorkorderPreferences[2].value.filter(x => x.key == this.props.getDetails.WorkOrderDetails.urgency)[0].key : "0" : "0",
                ProblemID: this.props.getDetails.WorkOrderDetails.workOrderDetail.problemID,
                Problem: (this.props.getDetails.WorkOrderDetails.workOrderDetail.problemID > 0 ? (this.props.getWorkorderPreferences.filter(x => x.field == this.props.getLabels['WorkOrderDetails.Problem.Text']).length > 0) ? this.props.getWorkorderPreferences[8].value.filter(x => x.key == this.props.getDetails.WorkOrderDetails.workOrderDetail.problemID)[0].value : "Light not working" : "--"),
                User: TechnicianName,
                UserID: this.props.getDetails.WorkOrderDetails.assignedUserID,
                IsEmailChecked:this.props.getDetails.WorkOrderDetails.isMailRequired,
                TenantName: this.props.getDetails.WorkOrderDetails.workOrderDetail.tenantName != "" ? this.props.getDetails.WorkOrderDetails.workOrderDetail.tenantName : unassigned,
                TenantId: this.props.getDetails.WorkOrderDetails.workOrderDetail.tenantID,
                disablecontrol: l_TenantId > 0 ? true : false,
                TenantLocation: l_TenantId > 0 ? ((this.props.getTenantList !== undefined && this.props.getTenantList.filter(e => e.tenantId === l_TenantId)[0] !== undefined) ? this.props.getTenantList.filter(e => e.tenantId === l_TenantId)[0].address : '') : '',
                SiteId: l_SiteId,
                BuildingDate: l_BuildingDate,
                SiteName: l_SiteId > 0 ? l_Buildings.name : unassigned,
                BuildingName: l_SiteId > 0 ? l_Buildings.name : unassigned,
                BuildingFloors: l_Buildings != null ? l_Buildings.floors : null,
                FloorId: l_FloorId,
                FloorName: l_Buildings != null && l_FloorId > 0 ? l_Buildings.floors.filter(e => e.id == l_FloorId)[0].name : unassigned,
                BuildingRooms: l_Rooms,
                RoomId: l_Rooms != null && l_SpaceId > 0 ? l_Rooms.filter(el => el.id == l_SpaceId)[0] !== undefined ? l_Rooms.filter(el => el.id == l_SpaceId)[0].id : 0 : 0,
                RoomName: l_Rooms != null && l_SpaceId > 0 ? l_Rooms.filter(el => el.id == l_SpaceId)[0] !== undefined ? l_Rooms.filter(el => el.id == l_SpaceId)[0].name : unassigned : unassigned,
                Description: this.props.getDetails.WorkOrderDetails.description,
                EquipmentId: this.props.EquipmentID !== undefined ? this.props.EquipmentID : 0,
                EquipmentName: (this.props.Equipment != '' && this.props.Equipment != '---') ? this.props.Equipment : unassigned,
                EquipmentLocation: (l_SiteId === 0 && l_LogicalBuildingId > 0) ? (this.props.getWorkOrderBuildings.length > 0 && this.props.getWorkOrderBuildings !== null && this.props.getWorkOrderBuildings !== undefined) ? this.props.getWorkOrderBuildings.filter(e => e.siteId === l_LogicalBuildingId)[0].name : this.props.getBuildingEquipments.filter(e => e.siteId === l_LogicalBuildingId)[0].siteName : l_SiteId > 0 ? l_Buildings.name : '',
                ServerTime: l_ServerTime,
                CreatedByUserName: (IsWOForm  ? this.props.getDetails.WorkOrderDetails.workOrderForm.emailAddress :  this.props.getDetails.WorkOrderDetails.createdByUserName) + ' | ' + new Date(this.props.getDetails.WorkOrderDetails.createdByDate).toDateString(),
                SerialNumber: this.props.getDetails.WorkOrderDetails.serialNumber,
                IsNonDiscoveredEquipment: this.props.getDetails.WorkOrderDetails.workOrderDetail.isNonDiscoveredEquipment,
                HasEmailAddress: MailAddress !== "" ? true : false,
                CreatedByUserID: this.props.getDetails.WorkOrderDetails.createdByUserID,
                WOCustomFields: this.props.getDetails.WorkOrderDetails.workOrderCustomFields,
                WOFormFirstName: (IsWOForm  ? this.props.getDetails.WorkOrderDetails.workOrderForm.firstName :  ''),
                WOFormLastName: (IsWOForm  ? this.props.getDetails.WorkOrderDetails.workOrderForm.lastName :  ''),
                WOFormEmailAddress: (IsWOForm  ? this.props.getDetails.WorkOrderDetails.workOrderForm.emailAddress : ''),
                IsWOCustomerForm: IsWOForm,
                SelectedNotifyOthersIds: lNotifyOthers,
            });
            g_CreatedDate = this.props.getDetails.WorkOrderDetails.createdByDate;   
            IsSelectedBuildingExists =  (l_Buildings != null && l_Buildings.isDeleted) ? false : true;      
            this.FormFloorSpaceDataOnLoad(l_SiteId, this.props.getDetails.WorkOrderDetails.workOrderDetail.tenantID);
            if(l_SiteId > 0 && l_Buildings != null && !l_Buildings.isDeleted)
                this.LoadBuildingEquipment(l_SiteId,l_Buildings.name);
        });
    }

    componentWillReceiveProps(nextProps) {
        if(this.props != nextProps && this.props.ForEquipment)
        {
            //this.setState({ BuildingId: this.props.AlarmInfo[0].SiteId, BuildingName: this.props.AlarmInfo[0].SiteName, EquipmentId: this.props.AlarmInfo[0].EquipmentId, EquipmentName: this.props.AlarmInfo[0].EquipmentName, Description: this.props.AlarmInfo[0].Description});     
        }
    }

    FormFloorSpaceDataOnLoad(l_SiteId, l_TenantId){
        //Forming Associate Building List
        if (l_TenantId !== "" && l_TenantId > 0) {
            const actionResponse = this.props.GetBuildingAssociation(l_TenantId);
            actionResponse.then((result) => {
                if (this.props.getTenantAssociations !== undefined && this.props.getTenantAssociations.length) {
                    let lBuildings = [];
                    this.props.getTenantAssociations.forEach(el => {
                        lBuildings.push({ 'id': el.buildingID, 'name': el.buildingName, 'buildingDate': el.buildingDate });
                    });
                    var Data = this.getUnique(lBuildings, 'id');
                    this.setState({ AssociateBuildings: Data });
                }
            })
        }

        //Form Floor & Space Collection
        const actionResponse = this.props.GetWorkOrderBuildings();
        actionResponse.then((result) => {
            var FloorCollection = [], SpaceCollection = [], l_Spacestdata = [];

            if (l_TenantId === "" || l_TenantId === 0) {
                var AvailableBuildings = (this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings.length) ? this.props.getWorkOrderBuildings.filter(el => el.isDeleted == false) : [];
                var SelectedObject = AvailableBuildings.filter(el => el.id == l_SiteId);
                FloorCollection = SelectedObject[0] !== undefined ? SelectedObject[0].floors : [];
                SpaceCollection = SelectedObject[0] !== undefined ? SelectedObject[0].spaces : [];
                l_Spacestdata = this.FormFinalFloorSpaceData(FloorCollection, SpaceCollection, l_SiteId);
            } else {
                l_Spacestdata = this.FormFloorSpaceData(l_SiteId);
            }
            this.setState({ SpacesData: l_Spacestdata });
        })
    }

    constructor(props) {
        super(props);
        this.state = {
            Buildings: this.props.getWorkOrderBuildings,
            dueDate: null,
            Status: 'Choose One',
            StatusId: 0,
            Urgency: 'Choose One',
            UrgencyId: 0,
            User: 'Choose One',
            UserID: 0,
            TenantName: '',
            TenantId: 0,
            TenantLocation: '',
            SiteName: '',
            SiteId: 0,
            BuildingDate: '',
            ServerTime: '',
            FloorId: 0,
            RoomId: 0,
            FloorName: '',
            BuildingFloors: null,
            RoomName: '',
            IsEmailChecked:false,
            BuildingRooms: null,
            Description: '',
            EquipmentName: '',
            EquipmentId: 0,
            IsNonDiscoveredEquipment: 0,
            EquipmentData:[],
            EquipmentLocation: '',
            LogicalBuildingId: 0,
            TenantDropDownStyles: CustomSelect,
            EquipmentDropDownStyles: CustomSelect,
            SpacesDropDownStyles: CustomSelect,
            IsError: false,
            disablecontrol:false,
            error:{
                tenant:false,
                building:false,
                floor:false,
                space:false,
                problem:false,
                description:false,
                urgency:false,
                equip:false,
                assignto:false,
                status:false,
                duedate:false,
                customname: false,
                notifyOthers:false
            },
            redirectHome: false,
            CreatedByUserName: '',
            ProblemID: 0,
            AssociateBuildings: [],
            TenantData:[],
            SpacesData:[],
            SerialNumber: '',
            HasEmailAddress: false,
            WOCustomFields: [],
            WOFormFirstName:'',
            WOFormLastName:'',
            WOFormEmailAddress:'',
            IsWOCustomerForm:false,
            SelectedNotifyOthersIds: [],
        }
        this.ComputeStyle = this.ComputeStyle.bind(this);
        this.ComputeEquipmentStyle = this.ComputeEquipmentStyle.bind(this);
        this.ComputeSpaceStyle = this.ComputeSpaceStyle.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleMouseScroll = this.handleMouseScroll.bind(this);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.setEquipmentWrapperRef =this.setEquipmentWrapperRef.bind(this);
        this.setSpaceWrapperRef = this.setSpaceWrapperRef.bind(this);
        this.setTenant = this.setTenant.bind(this);
        this.setEquipment = this.setEquipment.bind(this);
        this.setSpace = this.setSpace.bind(this);
        this.LoadBuildingFloors = this.LoadBuildingFloors.bind(this);
        this.OnStatusChange = this.OnStatusChange.bind(this);
        this.OnUserChange = this.OnUserChange.bind(this);
        this.OnUrgencyChange = this.OnUrgencyChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.SelectProblem = this.SelectProblem.bind(this);
        this.onWorkOrderUpdate = this.onWorkOrderUpdate.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.OnSort = this.OnSort.bind(this);
        this.emailChecked = this.emailChecked.bind(this);
        this.dropdown_fields = { text: 'value', value: 'id' };
    }

    updateDescriptionValue(evt) {
        this.setState({ Description: evt.target.value });
    }
    
    onCancel() {
        let IsEquipment = this.props.ForEquipment !== undefined && this.props.ForEquipment !== null ? this.props.ForEquipment : false;
        if(IsEquipment){
            this.props.ShowCreateButton();
            this.props.UpdateRedirection();
        }
        this.setState({ redirectHome: true });
    }

    emailChecked(event){
        this.setState({IsEmailChecked: event.target.checked});
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        document.addEventListener('wheel', this.handleMouseScroll);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.removeEventListener('wheel', this.handleMouseScroll);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    setEquipmentWrapperRef(node){
        this.equipWrapperRef = node;
    }

    setSpaceWrapperRef(node){
        this.spaceWrapperRef = node;
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            let StateChange = {...this.state.TenantDropDownStyles};
            StateChange.display = "none";
            this.setState({TenantDropDownStyles:StateChange});
        }
        if(this.equipWrapperRef && !this.equipWrapperRef.contains(event.target)){
            let EStateChange = {...this.state.EquipmentDropDownStyles};
            EStateChange.display = "none";
            this.setState({EquipmentDropDownStyles:EStateChange});            
        }
        if(this.spaceWrapperRef && !this.spaceWrapperRef.contains(event.target)){
            let SStateChange = {...this.state.SpacesDropDownStyles};
            SStateChange.display = "none";
            this.setState({SpacesDropDownStyles:SStateChange});            
        }
    }

    handleMouseScroll(event){
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            let StateChange = {...this.state.TenantDropDownStyles};
            StateChange.display = "none";
            this.setState({TenantDropDownStyles:StateChange}); 
        } 
        if(this.equipWrapperRef && !this.equipWrapperRef.contains(event.target)){
            let EStateChange = {...this.state.EquipmentDropDownStyles};
            EStateChange.display = "none";
            this.setState({EquipmentDropDownStyles:EStateChange}); 
        }
        if(this.spaceWrapperRef && !this.spaceWrapperRef.contains(event.target)){
            let SStateChange = {...this.state.SpacesDropDownStyles};
            SStateChange.display = "none";
            this.setState({SpacesDropDownStyles:SStateChange}); 
        }
    }

    OnSort(values) {
        const sorted_data = values.sort((a, b) => {
            let nameA, nameB;
            nameA = a.orderId;
            nameB = b.orderId;
            return (nameA - nameB);
        });
        return sorted_data;
    }

    LoadBuildingFloors() {
        //var FloorCollection = [], SpaceCollection = [], l_Spacestdata = [];
        var selectedOption = this.refs.buildings_in_Select_input.options.selectedIndex;
        //var selectedSiteId = this.refs.buildings_in_Select_input.options[selectedOption].id;

        // if(this.state.TenantId == ""){
        //     var AvailableBuildings = (this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings.length) ? this.props.getWorkOrderBuildings.filter(el => el.isDeleted == false) : [];
        //     var SelectedObject = AvailableBuildings.filter(el => el.id == selectedSiteId);
        //     FloorCollection = SelectedObject[0] !== undefined ? SelectedObject[0].floors : [];
        //     SpaceCollection = SelectedObject[0] !== undefined ? SelectedObject[0].spaces : [];
        //     l_Spacestdata = this.FormFinalFloorSpaceData(FloorCollection,SpaceCollection,selectedSiteId);
        // }else{
        //     l_Spacestdata = this.FormFloorSpaceData(selectedSiteId);
        // }

        let utcOffsetMinute = moment().utcOffset();
        var l_BuildingDate;
        if (utcOffsetMinute >= 0) {
            l_BuildingDate = moment(moment.parseZone(this.refs.buildings_in_Select_input.options[selectedOption].getAttribute('data-buildingDate')).format("YYYY-MM-DD")).add(utcOffsetMinute, 'minutes')
        }
        else {
            l_BuildingDate =  moment(moment.parseZone(this.refs.buildings_in_Select_input.options[selectedOption].getAttribute('data-buildingDate')).format("YYYY-MM-DD")).subtract(utcOffsetMinute, 'minutes')
        }

        this.setState({
            SiteId: this.refs.buildings_in_Select_input.options[selectedOption].id,
            BuildingName: this.refs.buildings_in_Select_input.options[selectedOption].value,
            BuildingDate: this.state.dueDate != null ? this.refs.buildings_in_Select_input.options[selectedOption].getAttribute('data-buildingDate') : l_BuildingDate,
            FloorId: 0,
            RoomId: 0,
            RoomName: '',
            EquipmentId:0,
            EquipmentName: ''
            //SpacesData: l_Spacestdata
        });

        if(!this.state.disablecontrol){
            this.setState({TenantId: 0,TenantName: ''});
        }
        IsSelectedBuildingExists = true;
        this.LoadBuildingEquipment(0,'');
    }

    OnStatusChange() {
        var selectedOption = this.refs.status_in_Select_input.options.selectedIndex;

        this.setState({
            StatusId: this.refs.status_in_Select_input.options[selectedOption].id,
            Status: this.refs.status_in_Select_input.options[selectedOption].value,
        });
    }

    OnUserChange() {
        var selectedOption = this.refs.user_in_Select_input.options.selectedIndex;
        var selectedUserId = this.refs.user_in_Select_input.options[selectedOption].id;
        var MailAddress = "";
        if(selectedUserId !== '0' && this.props.getTechnicianList !== undefined && this.props.getTechnicianList.length)
            MailAddress = this.props.getTechnicianList.filter(x => x.technicianID == selectedUserId)[0].emailAddress;
        this.setState({
            UserID: selectedUserId,
            User: this.refs.user_in_Select_input.options[selectedOption].value,
            IsEmailChecked: MailAddress !== "" ? true : false,
            HasEmailAddress: MailAddress !== "" ? true : false,
            SelectedNotifyOthersIds: selectedUserId !== '0' ? this.state.SelectedNotifyOthersIds.filter(e => e !== Number(selectedUserId)) : this.state.SelectedNotifyOthersIds,
        });
    }

    onNotifyOthersSelect(args){
        var l_SelectedNotifyOthersIds = (this.state.SelectedNotifyOthersIds !== undefined && this.state.SelectedNotifyOthersIds.length) ? this.state.SelectedNotifyOthersIds : [];
        l_SelectedNotifyOthersIds.push(args.itemData.id);
        this.setState({SelectedNotifyOthersIds:  l_SelectedNotifyOthersIds})
    }

    onNotifyOthersRemove(args){
        var l_SelectedNotifyOthersIds = this.state.SelectedNotifyOthersIds;
        var FilteredData = l_SelectedNotifyOthersIds.filter(x => x !== args.itemData.id);
        this.setState({SelectedNotifyOthersIds: FilteredData });
    }

    OnUrgencyChange() {
        var selectedOption = this.refs.urgencys_in_Select_input.options.selectedIndex;

        this.setState({
            UrgencyId: this.refs.urgencys_in_Select_input.options[selectedOption].id,
            Urgency: this.refs.urgencys_in_Select_input.options[selectedOption].value,
        });
    }

    handleChange(date) {
        if(date !== null){
            var myDate = new Date(date);
            var fDate;
            let utcOffsetMinute = moment().utcOffset();
            
            // if (this.state.dueDate == null && utcOffsetMinute < 0) {
            //     myDate = moment(moment.parseZone(myDate).format("YYYY-MM-DD")).add(1, 'days');
            // }
    
            if (utcOffsetMinute >= 0) {
                fDate = moment(moment.parseZone(myDate).format("YYYY-MM-DD")).add(utcOffsetMinute, 'minutes')
            }
            else {
                fDate = moment(moment.parseZone(myDate).format("YYYY-MM-DD")).subtract(utcOffsetMinute, 'minutes')
            }
            this.setState({
                dueDate: new Date(fDate)
            });
        }else{
            this.setState({
                dueDate: null
            });
        }
    }

    SelectProblem(){
        var selectedOption = this.refs.problems_in_Select_input.options.selectedIndex;
        var selectedProblemId = this.refs.problems_in_Select_input.options[selectedOption].id;  
        this.setState({ProblemID:selectedProblemId});       
    }


    onWorkOrderUpdate() {
        this.ClearCustomErrors();
        let preferredfields = this.props.getWorkorderPreferences;

        var tenant = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Tenant")[0] : "";
        var building = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Building")[0] : "";       
        var floor =  preferredfields !== undefined ? preferredfields.filter(x => x.field === "Floor")[0] : "";       
        var space = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Space")[0] : "";       
        var problem = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Problem")[0] : "";        
        var description = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Description")[0] : "";
        var urgency = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Urgency")[0] : "";
        var assignedto = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Assigned To")[0] : "";
        var equipment = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Equipment")[0] : "";
        var status = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Status")[0] : "";
        var notifyOthers = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Notify Others")[0] : "";
        var dueDate = preferredfields !== undefined ? preferredfields.filter(x => x.field === "DueDate")[0] : "";
        //var selectedOption, selectedSiteId = 0;

        var IsChecked_email = this.state.IsEmailChecked;

        (!tenant.required || (tenant.required == true && this.state.TenantId != ''))? this.state.error.tenant=false : this.state.error.tenant=true;
        (!building.required || (building.required == true && this.state.SiteId > 0))? this.state.error.building=false : this.state.error.building=true;
        (!floor.required || (floor.required == true && (this.state.RoomId != "" || this.state.FloorId !="")))? this.state.error.floor=false : this.state.error.floor=true;
        (!space.required || (space.required == true && (this.state.RoomId != "" || this.state.FloorId !="")))? this.state.error.space=false : this.state.error.space=true;
        (!problem.required || (problem.required == true && this.state.ProblemID >0))? this.state.error.problem=false : this.state.error.problem=true;
        (!description.required || (description.required == true && this.refs.description.value != ""))? this.state.error.description=false : this.state.error.description=true;
        (!urgency.required || (urgency.required == true && this.state.UrgencyId > 0))?this.state.error.urgency=false : this.state.error.urgency=true;
        (!equipment.required || (equipment.required == true && this.state.EquipmentId > 0))?this.state.error.equip=false : this.state.error.equip=true;
        (!assignedto.required || (assignedto.required == true && this.state.UserID > 0))?this.state.error.assignto=false : this.state.error.assignto=true;
        (!status.required || (status.required == true && this.state.StatusId > 0))?this.state.error.status=false : this.state.error.status=true;
        (!notifyOthers.required || (notifyOthers.required == true && this.state.SelectedNotifyOthersIds.length > 0)) ? this.state.error.notifyOthers = false : this.state.error.notifyOthers = true;
        (!dueDate.required || (dueDate.required == true && this.state.dueDate != null)) ? this.state.error.duedate = false : this.state.error.duedate = true;
        // if (this.state.StatusId > 0 && (!assignedto.required || (assignedto.required && this.state.UserID > 0)) && (!urgency.required || (urgency.required && this.state.UrgencyId > 0)) && this.state.dueDate != null) {
        
        //custom fields validations
        var lCustomFieldCol = [];
        var lCustomColtxts = document.getElementsByClassName("customfieldsColtxt");
        if(lCustomColtxts !== undefined && lCustomColtxts !== null && lCustomColtxts.length){
            for(var i=0; i<lCustomColtxts.length; i++){
                var lChildrens = lCustomColtxts[i].childNodes;
                var CustomTxtBoxValue = lChildrens[2].value;
                CustomTxtBoxValue = CustomTxtBoxValue.trim();
                var CustomTxtBoxAttr = lChildrens[2].getAttribute("data-key");
                if(CustomTxtBoxAttr.split('~')[1] === "true" && !!CustomTxtBoxValue === false){
                    lChildrens[0].classList.add('errortext');
                    lChildrens[2].style.width = "81%";
                    lChildrens[2].classList.add('errorhighlight');
                    lChildrens[3].removeAttribute('hidden');
                    this.state.error.customname = true;
                }
                lCustomFieldCol.push({
                    "CustomFieldID" : Number(CustomTxtBoxAttr.split('~')[0]),
                    "CustomFieldValueID" : 0,
                    "CustomFieldTextValue" : CustomTxtBoxValue
                });
            }
        }
        var lCustomColddls = document.getElementsByClassName("customfieldsColddl");
        if(lCustomColddls !== undefined && lCustomColddls !== null && lCustomColddls.length){
            for(var i=0; i<lCustomColddls.length; i++){
                var lChildrens = lCustomColddls[i].childNodes;
                var CustomddlIndex = lChildrens[2].options.selectedIndex;
                var CustomddlValue = lChildrens[2].options[CustomddlIndex].id;
                var CustomddlAttr = lChildrens[2].getAttribute("data-key");
                if(CustomddlAttr.split('~')[1] === "true" && CustomddlValue === "0"){
                    lChildrens[0].classList.add('errortext');
                    lChildrens[2].classList.add('errorhighlight');
                    lChildrens[3].removeAttribute('hidden');
                    this.state.error.customname = true;
                }
                lCustomFieldCol.push({
                    "CustomFieldID" : Number(CustomddlAttr.split('~')[0]),
                    "CustomFieldValueID" : Number(CustomddlValue),
                    "CustomFieldTextValue" : ""
                });
            }
        }
        
        if(!this.state.error.tenant && !this.state.error.building && !this.state.error.floor && !this.state.error.space && !this.state.error.assignto && !this.state.error.problem && !this.state.error.description &&
            !this.state.error.urgency && !this.state.error.equip && !this.state.error.status && !this.state.error.duedate && !this.state.error.customname && !this.state.error.notifyOthers){  
                if(this.refs.ref_Assigned_User != undefined || this.refs.ref_Assigned_User != null)
                    IsChecked_email = this.refs.ref_Assigned_User.checked;
                let IsEquipment = this.props.ForEquipment !== undefined && this.props.ForEquipment !== null ? this.props.ForEquipment : false;
                let EquipmentSummaryId;
                if(IsEquipment === true && this.props.EquipmentSummary[0].EquipmentID > 0)
                 EquipmentSummaryId = this.props.EquipmentSummary[0].EquipmentID;
                 else if(IsEquipment === true && this.props.EquipmentSummary !== undefined )
                 EquipmentSummaryId = window.top.location.href.split("EquipmentId=")[1].split("&")[0];
                let lineitem = {
                    "WorkOrderID": this.props.TaskId,
                    "SerialNumber": this.state.SerialNumber,
                    "Status": this.state.StatusId,
                    "AssignedUserID": this.state.UserID,
                    "IsMailRequired" : IsChecked_email,
                    "DueDate": this.state.dueDate !== null ? this.state.dueDate : '1753-01-01T00:00:00',
                    "Urgency": this.state.UrgencyId,
                    "CreatedByDate": g_CreatedDate,
                    "WorkOrderDetail": {
                        "TenantID": (this.state.TenantId != '') ? this.state.TenantId : 0,
                        "TenantName": (this.state.TenantId != '') ? this.state.TenantName : 'NOT ASSIGNED',
                        "SiteID": IsSelectedBuildingExists ? this.state.SiteId : 0,
                        "SiteName": this.state.SiteId != '' && this.state.SiteId != '0' ? this.state.BuildingName : 'NOT ASSIGNED',
                        "FloorID": this.state.FloorId !== "" ? this.state.FloorId : 0,
                        "SpaceID": this.state.RoomId != '' ? this.state.RoomId : 0,
                        "EquipmentID": this.state.EquipmentId !== "" ? this.state.EquipmentId : 0,
                        "EquipmentName":(this.state.EquipmentName != '')? this.state.EquipmentName : 'NOT ASSIGNED',
                        "IsNonDiscoveredEquipment" : this.state.IsNonDiscoveredEquipment !== "" ? this.state.IsNonDiscoveredEquipment : false,
                        "ProblemID": this.state.ProblemID,
                        "OtherProblem":'',
                        "LogicalBuildingID": this.state.LogicalBuildingId
                    },
                    "WorkOrderForm":{
                        "FirstName": this.state.WOFormFirstName,
                        "LastName": this.state.WOFormLastName,
                        "EmailAddress": this.state.WOFormEmailAddress,
                        "IsCustomerForm": this.state.IsWOCustomerForm,
                    },
                    "Description": this.state.Description,
                    "createdByUserID": this.state.CreatedByUserID,
                    "EquipmentSummaryID" : (IsEquipment === true) ? EquipmentSummaryId : 0,
                    "WorkOrderCustomFields": lCustomFieldCol,
                    "NotifyUserIDs": this.state.SelectedNotifyOthersIds,
                }
             const l_Request = this.props.UpdateWorkOrder(lineitem, this.props.TaskId);
                l_Request.then((result) => {                    
                    if(IsEquipment){
                        this.props.UpdateRedirection();
                        this.props.ShowCreateButton();
                    }
                    this.setState({ redirectHome: true, IsError: false });
                });
            }
        else {
            this.setState({ IsError: true });
        }
    }

    ComputeStyle(){
        var offset = ReactDOM.findDOMNode(this.refs.tenants_in_Select_input).getBoundingClientRect();
        let StateChange = {...this.state.TenantDropDownStyles};
        StateChange.display = "block";
        StateChange.top = parseInt(offset.top) + parseInt(offset.height) + 1;
        StateChange.left= parseInt(offset.left);
        this.setState({TenantDropDownStyles:StateChange});
    }

    ComputeEquipmentStyle(){
        var offset = ReactDOM.findDOMNode(this.refs.equipments_in_Select_input).getBoundingClientRect();
        let StateChange = {...this.state.EquipmentDropDownStyles};
        StateChange.display = "block";
        StateChange.top = parseInt(offset.top) + parseInt(offset.height) + 1;
        StateChange.left= parseInt(offset.left);
        this.setState({EquipmentDropDownStyles:StateChange});
    }

    ComputeSpaceStyle(){
        var offset = ReactDOM.findDOMNode(this.refs.Spaces_in_Select_input).getBoundingClientRect();
        let StateChange = {...this.state.SpacesDropDownStyles};
        StateChange.display = "block";
        StateChange.top = parseInt(offset.top) + parseInt(offset.height) + 1;
        StateChange.left= parseInt(offset.left);
        this.setState({SpacesDropDownStyles:StateChange});
    }

    setEquipment(id,name,location,isNonDiscovered){
        var logicalBuildingId;
        if(this.state.SiteId === 0){
            var FilterValue = this.props.getBuildingEquipments.filter(e => e.siteName === location);
            if(FilterValue[0] !== undefined && FilterValue[0] !== null)
                logicalBuildingId = this.props.getBuildingEquipments.filter(e => e.siteName === location)[0].siteId;
            else
                logicalBuildingId = 0;
        }else{
            logicalBuildingId = 0;
        }         
        let StateChange = {...this.state.EquipmentDropDownStyles};
        StateChange.display = "none";

        this.setState({
            EquipmentId:id,
            EquipmentName:name,
            IsNonDiscoveredEquipment: isNonDiscovered,
            EquipmentDropDownStyles:StateChange,
            LogicalBuildingId: logicalBuildingId,
            EquipmentLocation: location}); 
    }

    setSpace(id,name,subId,buildingId)
    {
        let StateChange = {...this.state.EquipmentDropDownStyles};
        StateChange.display = "none";
        
        if(subId === ''){
            this.setState({
                RoomId:0,
                RoomName:name,
                FloorId:id,
                SiteId: buildingId,
                BuildingDate: this.props.getWorkOrderBuildings.filter(el => el.id == buildingId && el.isDeleted == false)[0].buildingDate,
                SpacesDropDownStyles:StateChange}); 
        } else {
            this.setState({
                RoomId: id,
                RoomName: name,
                FloorId: subId,
                SiteId: buildingId,
                BuildingDate: this.props.getWorkOrderBuildings.filter(el => el.id == buildingId && el.isDeleted == false)[0].buildingDate,
                SpacesDropDownStyles: StateChange
            });
        }
    }

    setTenant(id, name, location, subId) {
        let StateChange = { ...this.state.TenantDropDownStyles };
        StateChange.display = "none";

        // var SelectedObject = this.props.getWorkOrderBuildings.filter(el => el.tenantID == id);

        // this.setState({ AssociateBuildings: [], RoomName: '', EquipmentName: '', SpacesData: [] });
        // if (this.props.getWorkorderPreferences.filter(x => x.field === this.props.getLabels['WorkOrderDetails.Building.Text'] && x.display === true).length > 0)
        //     this.refs.buildings_in_Select_input.options.selectedIndex = '0';
        
        this.GetTenantAssociateBuildings(id);
        this.setState({
            TenantId: id,
            TenantName: name,
            //Buildings: SelectedObject,
            //SiteId: 0,
            FloorId: 0,
            RoomId: 0,
            //EquipmentId: 0,
            //EquipmentData: [],
            TenantDropDownStyles: StateChange,
            TenantLocation: location
        });
    }

    GetTenantAssociateBuildings(id){
        const actionResponse = this.props.GetBuildingAssociation(id);
        actionResponse.then((result) => {
            if (this.props.getTenantAssociations !== undefined && this.props.getTenantAssociations.length) {
                let lBuildings = [];
                this.props.getTenantAssociations.forEach(el => {
                    lBuildings.push({ 'id': el.buildingID, 'name': el.buildingName });
                });
                var Data = this.getUnique(lBuildings, 'id');
                let l_Spacestdata = this.LoadData();
                this.setState({ AssociateBuildings: Data, SpacesData: l_Spacestdata });
            }
        })
    }

    getUnique(arr, comp) {

        const unique = arr
             .map(e => e[comp])
      
           // store the keys of the unique objects
          .map((e, i, final) => final.indexOf(e) === i && i)
      
          // eliminate the dead keys & store unique objects
          .filter(e => arr[e]).map(e => arr[e]);
      
         return unique;
    }

    LoadData(){
        var SelectedBuildingIds = [];
        var l_Spacestdata = [];
        var SelectedItems = this.props.getTenantAssociations;

        SelectedItems.forEach(element => {
            SelectedBuildingIds.push(element.buildingID);
        });
        SelectedBuildingIds = SelectedBuildingIds.filter((val, id, array) => array.indexOf(val) == id);

        if(SelectedBuildingIds.length){
            for(var i=0; i<SelectedBuildingIds.length; i++){
                var LineItem = this.FormFloorSpaceData(SelectedBuildingIds[i]);
                if(LineItem !== undefined && LineItem.length){
                    for(var j=0; j<LineItem.length; j++)
                        l_Spacestdata.push(LineItem[j]);
                }
            }
        }
        return l_Spacestdata;
    }

    FormFloorSpaceData(selectedSiteId){
        var FloorCollection = [], SpaceCollection = [], l_Spacestdata = [];
        var SelectedItems = this.props.getTenantAssociations.filter(el => el.buildingID == selectedSiteId);

        if (SelectedItems !== undefined && SelectedItems.length) {
            var SelectedFloorIds = [], SelectedSpaceIds = [];
            SelectedItems.forEach(element => {
                if (element.floorID !== 0) {
                    SelectedFloorIds.push(element.floorID);
                }
                else {
                    SelectedSpaceIds.push(element.spaceID);
                }
            });

            if (SelectedFloorIds.length) {
                SelectedFloorIds = SelectedFloorIds.filter((val, id, array) => array.indexOf(val) == id);
                for (var i = 0; i < SelectedFloorIds.length; i++) {
                    var FilterData = SelectedItems.filter(x => x.floorID == SelectedFloorIds[i]);
                    if (FilterData !== undefined && FilterData.length) {
                        var SpaceInputCollection = [];
                        for (var j = 0; j < FilterData.length; j++) {
                            if (FilterData[j].spaceID !== 0)
                                SpaceInputCollection[j] = { 'id': FilterData[j].spaceID, 'name': FilterData[j].spaceName };
                        }
                        FloorCollection[i] = { 'id': FilterData[0].floorID, 'name': FilterData[0].floorName, spaces: SpaceInputCollection };
                    }
                }
            }
            if (SelectedSpaceIds !== undefined && SelectedSpaceIds !== null && SelectedSpaceIds.length) {
                for (var i = 0; i < SelectedSpaceIds.length; i++) {
                    var FilterData = SelectedItems.filter(x => x.spaceID == SelectedSpaceIds[i]);
                    SpaceCollection[i] = { 'id': FilterData[0].spaceID, 'name': FilterData[0].spaceName };
                }
            }
        }
        l_Spacestdata = this.FormFinalFloorSpaceData(FloorCollection,SpaceCollection,selectedSiteId);
        return l_Spacestdata;
    }

    FormFinalFloorSpaceData(FloorCollection,SpaceCollection,SiteId){
        var l_Spacestdata = [], Spacelineitem = '';
        FloorCollection.forEach(element => {
            var l_FloorName = element.name;
            var l_FloorId = element.id;

        if(element.spaces.length > 0){
            element.spaces.forEach(el => {
            Spacelineitem = {
                "Id": el.id,
                "Name": el.name,
                "Location": l_FloorName,
                "SubId": l_FloorId,
                "BuildingId": SiteId
            }
            l_Spacestdata.push(Spacelineitem);
            });
        }
        else{
            Spacelineitem ={
                "Id": element.id,
                "Name": element.name, 
                "Location": "",
                "SubId": "",
                "BuildingId": SiteId
            }
            l_Spacestdata.push(Spacelineitem);
        }
        });

        SpaceCollection.forEach(element => {
            Spacelineitem = {
                "Id": element.id,
                "Name": element.name,
                "Location": "",
                "SubId": 0,
                "BuildingId": SiteId
            }
            l_Spacestdata.push(Spacelineitem);
        });
        return l_Spacestdata;
    }

    LoadBuildingEquipment(l_SiteID, l_SiteName) {
        var selectedOption = this.refs.buildings_in_Select_input.options.selectedIndex;
        var selectedSiteId = l_SiteID === 0 ? this.refs.buildings_in_Select_input.options[selectedOption].id : l_SiteID;
        var actualSiteId = 0;
        if(this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings.length > 0 &&
            selectedSiteId > 0)
        {
            var l_MappedSite = this.props.getWorkOrderBuildings.filter(x => x.id == selectedSiteId);
            if(l_MappedSite !== undefined && l_MappedSite.length > 0)
            {
                actualSiteId = l_MappedSite[0].siteId;
            }            
        }
        var l_SelectedBuilding = this.props.getBuildingEquipments.filter(el => el.siteId == actualSiteId);
        var l_Equipmentdata = []

        if (l_SelectedBuilding !== undefined && l_SelectedBuilding !== null && l_SelectedBuilding.length > 0) {
            var Equiplineitem = '';
            l_SelectedBuilding.forEach(building => {
                if(building.equipment !== undefined && building.equipment !== null && building.equipment.length > 0)
                {
                    let siteName = building.siteName;
                    building.equipment.forEach(element => {
                        Equiplineitem = {
                            "Id": element.objectId,
                            "Name": element.objectName,
                            "Location": siteName,
                            "SubId": 0,
                        }
                        l_Equipmentdata.push(Equiplineitem);
                    });
                }                
            });
        };

        
        var l_SelectedBuildingEquipment = this.props.getEquipments.filter(el => el.siteId == selectedSiteId)
        if (l_SelectedBuildingEquipment !== undefined && l_SelectedBuildingEquipment !== null && l_SelectedBuildingEquipment.length > 0) {
            var Equiplineitem = '';
            l_SelectedBuildingEquipment.forEach(Equipment => {
                Equiplineitem = {
                    "Id": Equipment.id,
                    "Name": Equipment.name,
                    "Location": Equipment.buildingName,
                    "SubId": 1,
                }
                l_Equipmentdata.push(Equiplineitem);
            });
        }

        if (l_SiteID === 0) {
            this.setState({
                EquipmentId: 0,
                EquipmentName: '',
                EquipmentData: l_Equipmentdata
            });
        } else {
            this.setState({ EquipmentData: l_Equipmentdata });
        }
    }

    ClearCustomErrors(){
        this.state.error.customname = false;
        var lCustomColtxts = document.getElementsByClassName("customfieldsColtxt");
        if(lCustomColtxts !== undefined && lCustomColtxts !== null && lCustomColtxts.length){
            for(var i=0; i<lCustomColtxts.length; i++){
                var lChildrens = lCustomColtxts[i].childNodes;
                lChildrens[0].classList.remove('errortext');
                lChildrens[2].style.width = "100%";
                lChildrens[2].classList.remove('errorhighlight');
                lChildrens[3].setAttribute('hidden',true);
            }
        }
        var lCustomColddls = document.getElementsByClassName("customfieldsColddl");
        if(lCustomColddls !== undefined && lCustomColddls !== null && lCustomColddls.length){
            for(var i=0; i<lCustomColddls.length; i++){
                var lChildrens = lCustomColddls[i].childNodes;
                lChildrens[0].classList.remove('errortext');
                lChildrens[2].classList.remove('errorhighlight');
                lChildrens[3].setAttribute('hidden',true);
            }
        }
    }

    FormCustomFields(WoCustomFields){
        const l_rows = [];
        var Default_drop_down_value = <option value="" id="0" selected>{this.props.getLabels['WorkOrders.DropDown.Default.Text']}</option>
        if(this.props.getCustomFields !== undefined && this.props.getCustomFields !== null && this.props.getCustomFields.length){
            var lCustomFields = this.props.getCustomFields.filter(el => el.display === true);
            if(lCustomFields !== undefined && lCustomFields !== null && lCustomFields.length){
                var l_CustomFields = this.OnSort(lCustomFields);
                const l_lstCustomFields = l_CustomFields.map((item) => {
                    var SelectedValues = WoCustomFields.filter(el => el.customFieldID === item.fieldId);
                    var l_Value = "";
                    if(SelectedValues[0] !== undefined && SelectedValues[0] !== null){
                        l_Value = (item.fieldType === 0) ? SelectedValues[0].customFieldTextValue : SelectedValues[0].customFieldValueID;
                    }
                    if(item.fieldType === 0){
                        return <Col className="customfieldsColtxt" key={item.fieldId} sm={{ size: 2 }}>
                                <Label className="workorderlbl">{(item.required) ? item.fieldLabel + "*" : item.fieldLabel}</Label>
                                <br />
                                <input type="text" maxLength={50} data-key={item.fieldId + '~' + item.required} defaultValue={l_Value} style={{width: '100%'}} className="pm_textbox customtxtbox" />
                                <span hidden={true}><Icon name='exclamation triangle' style={ErrorSign} /><br/>
                                <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}><b>An entry is required</b></Label></span>
                            </Col>
                    }else{
                        var CustomValue_in_Select_input;
                        if (item.value !== undefined && item.value !== null && item.value.length > 0) {
                            var custom_values = this.OnSort(item.value);
                            CustomValue_in_Select_input = custom_values.map(el => (
                                <option id={el.key} selected={el.key == l_Value}>{el.value}</option>
                            ));
                        }
                        return <Col className="customfieldsColddl" key={item.fieldId} sm={{ size: 2 }}>
                                <Label className="workorderlbl">{(item.required) ? item.fieldLabel + "*" : item.fieldLabel}</Label><br />
                                <select data-key={item.fieldId + '~' + item.required} id={"ddl_"+item.fieldId} className="minimal workorderedit-dropdown" style={{width: '100%'}}>
                                    {Default_drop_down_value}
                                    {CustomValue_in_Select_input}
                                </select>
                                <span hidden={true}><Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}><b>Please make a selection</b></Label></span>
                            </Col>
                    }
                });
                
                // Push a new row for every set of three fields
                for (let row = 0; row < Math.ceil(l_CustomFields.length / 3); row++) {
                    l_rows.push(<div key={"div_"+row} className="row form-group">
                        {l_lstCustomFields.slice((row * 3), ((row + 1) * 3))}
                    </div>);
                };
            }
        }
        return l_rows;
    }

    render(getWorkorderPreferences) {
        let IsEquipment = this.props.ForEquipment !== undefined && this.props.ForEquipment !== null ? this.props.ForEquipment : false;
        let BuildingsList;
        let label = this.props.getLabels;
        let PreferedDateFormat = this.props.UserPreference_response;
        let preferredfields = this.props.getWorkorderPreferences;
        let HasMailSetting = this.props.getMailSetting;

        let UserFormat = Conversions.UserPreferenceDateFormat_DatePicker(PreferedDateFormat);
        if (this.state.redirectHome && !IsEquipment) {
            return <Redirect to={"/ManageWorkOrder"} />
        }
        else if(this.state.redirectHome && IsEquipment){
            return <Redirect to ={"/EquipmentWrapper"}/>
        }

        var tenant = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Tenant" && x.display === true) : "";
        var building = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Building" && x.display === true) : "";
        var floor = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Floor" && x.display === true) : "";
        var space = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Space" && x.display === true) : "";
        var problem = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Problem" && x.display === true) : "";
        var description = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Description" && x.display === true) : "";
        var urgency = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Urgency" && x.display === true) : "";
        var equipment = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Equipment" && x.display === true) : "";
        var status = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Status" && x.display === true) : "";
        var assignedto = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Assigned To" && x.display === true) : "";
        var createdby = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Created" && x.display === true) : "";
        var notifyOthers = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Notify Others" && x.display === true) : "";
        var dueDate = (preferredfields !== ""  && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "DueDate" && x.display === true) : "";

        var errormsg, problems_in_Select_input = null, urgency_in_Select_input = null, status_in_Select_input = null, buildings_in_Select_input = null;
        var technicians_in_Select_input = null, notifiers_in_Select_input = [];
        var Default_drop_down_value = <option id={0}>{label['WorkOrders.DropDown.Default.Text']}</option>
        var selecterrortext;
        if (this.state.IsError) {
            errormsg = <p style={ErrorPadding}>
                         <Icon name='exclamation triangle' style={ErrorSign}/>
                         <b>Please correct all errors before continuing.</b>
                       </p>
        }
        selecterrortext = <Label style={{'color':'#D42D27', 'font-style':'italic','font-size':'10px','font-family':'Lato' }}><b>Please make a selection</b></Label>
        if (this.props.getTechnicianList != undefined && this.props.getTechnicianList != null) {
            let lSortedTechnicianlst = this.props.getTechnicianList.sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) - (a.name.toLowerCase() < b.name.toLowerCase()));
            technicians_in_Select_input = lSortedTechnicianlst.map(el => (
                <option id={el.technicianID} selected={el.technicianID == this.state.UserID}>{el.name}</option>
            ));
            lSortedTechnicianlst.forEach(el => {
                if(el.technicianID !== Number(this.state.UserID) && el.emailAddress !== ""){
                    notifiers_in_Select_input.push({ "id": el.technicianID, "value" : el.name })
                }
            });
        }
        if(this.props.getWorkOrderBuildings != null && this.props.getWorkOrderBuildings != undefined && this.props.getWorkOrderBuildings.length>0)
            BuildingsList = this.props.getWorkOrderBuildings.filter(el => el.isDeleted == false).sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) - (a.name.toLowerCase() < b.name.toLowerCase()));
        if (this.state.TenantId !== 0 && this.state.AssociateBuildings !== undefined && this.state.AssociateBuildings.length) {
            buildings_in_Select_input = this.state.AssociateBuildings.map(el => (
                <option id={el.id} selected={el.id == this.state.SiteId} data-buildingDate={el.buildingDate}>{el.name}</option>
            ));
        } 
        else if(this.state.TenantId !== 0 && this.state.AssociateBuildings !== undefined && this.state.AssociateBuildings.length === 0){
            buildings_in_Select_input = null;
        }
        else {
            if (BuildingsList != null && BuildingsList != undefined && BuildingsList.length > 0) {
                buildings_in_Select_input = BuildingsList.map(el => (
                    <option id={el.id} selected={el.id == this.state.SiteId} data-buildingDate={el.buildingDate}>{el.name}</option>
                ));
            }
        }

        if(this.state.SiteId > 0 && IsSelectedBuildingExists)
        {
            if (this.props.getTenantList != undefined) {
            var l_data = [], lineitem = '';
            this.props.getTenantList.sort((a,b) => (a.tenantName.toLowerCase() > b.tenantName.toLowerCase()) - (a.tenantName.toLowerCase() < b.tenantName.toLowerCase())).forEach(element => {
                if(element.buildings != undefined){                   
                if (element.buildings.filter(x => x.buildingId == this.state.SiteId).length > 0) {
                    lineitem = {
                        "Id": element.tenantId,
                        "Name": element.tenantName, //this.FormValidDate(this.state.start_date),
                        "Location": element.address, //this.FormValidDate(this.state.end_date),
                        "SubId": 0,
                    }
                    l_data.push(lineitem);
                }
               }
            });
            this.state.TenantData = l_data;
        }
    }
    else{
        if (this.props.getTenantList != undefined) {
            var l_data = [], lineitem = '';
            this.props.getTenantList.sort((a,b) => (a.tenantName.toLowerCase() > b.tenantName.toLowerCase()) - (a.tenantName.toLowerCase() < b.tenantName.toLowerCase())).forEach(element => {
                lineitem = {
                    "Id": element.tenantId,
                    "Name": element.tenantName, //this.FormValidDate(this.state.start_date),
                    "Location": element.address, //this.FormValidDate(this.state.end_date),
                    "SubId": 0,
                }
                l_data.push(lineitem);
            });
            this.state.TenantData = l_data;
        }
    }

        if (this.props.getBuildingEquipments != undefined && this.props.getBuildingEquipments.length > 0 &&
            (this.state.SiteId === undefined || this.state.SiteId <= 0 ) && this.state.EquipmentData.length == 0) {
            var l_Equipmentdata = [], Equiplineitem = '';
            
            this.props.getBuildingEquipments.forEach(building => {                
                if(building.equipment !== undefined && building.equipment !== null && building.equipment.length > 0)
                {
                    let siteName = building.siteName;
                    building.equipment.forEach(element => {
                        Equiplineitem = {
                            "Id": element.objectId,
                            "Name": element.objectName,
                            "Location": siteName,
                            "SubId": 0,
                        }
                        l_Equipmentdata.push(Equiplineitem);
                    });
                }                
            });

            if (this.props.getEquipments != undefined && this.props.getEquipments.length > 0) {
                this.props.getEquipments.forEach(NonDiscEquip => {
                    Equiplineitem = {
                        "Id": NonDiscEquip.id,
                        "Name": NonDiscEquip.name,
                        "Location": NonDiscEquip.buildingName,
                        "SubId": 1,
                    }
                    l_Equipmentdata.push(Equiplineitem);
                });
            }

            this.state.EquipmentData = l_Equipmentdata;
        }

        var Problems = label['WorkOrders.Problem.Text'].split(',');
        if (problem.length > 0) {
            if (problem[0].value.length > 0) {
                var problem_values = this.OnSort(problem[0].value);
                problems_in_Select_input = problem_values.map(el => (
                    <option id={el.key} selected={el.key == this.state.ProblemID}>{el.value}</option>
                ));
            }
            else {
                problems_in_Select_input = Problems.map(el => (
                    <option id={el}>{label['WorkOrders.Problem.' + el + '.Text']}</option>
                ));
            }
        }

        var Urgency = label['WorkOrders.Urgency.Text'].split(',');
        if (urgency.length > 0) {
            if (urgency[0].value.length > 0) {
                var urgency_values = this.OnSort(urgency[0].value);
                urgency_in_Select_input = urgency_values.map(el => (
                    <option id={el.key} selected={el.key == this.state.UrgencyId}>{el.value}</option>
                ));
            }
            else {
                urgency_in_Select_input = Urgency.map(el => (
                    <option id={el}>{label['WorkOrders.Urgency.' + el + '.Text']}</option>
                ));
            }
        }

        var Status = label['WorkOrders.Status.Text'].split(',');
        if (status.length > 0) {
            if (status[0].value.length > 0) {
                var status_values = this.OnSort(status[0].value);
                status_in_Select_input = status_values.map(el => (
                    <option id={el.key} selected={el.key == this.state.StatusId}>{el.value}</option>
                ));
            }
            else {
                status_in_Select_input = Status.map(el => (
                    <option id={el} value={el} >{label['WorkOrders.Status.' + el + '.Text']}</option>
                ));
            }
        }
        
        //Applying Custom Fields
        let lstCustomFields= this.FormCustomFields(this.state.WOCustomFields);

        return (
            <div className= {this.props.Premise ? "main_container" : "cloud_main_container"}>
                <table style={{'width':'100%'}}>
                    <tr>
                        <td>
                            {errormsg}
                        </td>
                    </tr>
                    {(assignedto.length > 0) ?
                    <tr> 
                        <td>
                            <p style={{ 'float': 'right', 'margin-right': this.props.ForEquipment ? '50px': '63px', 'margin-top': '-18px', 'margin-bottom': '9px' }} >
                                <input type="checkbox" style={{'vertical-align':'middle'}} id="assigned_box" disabled={!HasMailSetting || !this.state.HasEmailAddress} checked={this.state.IsEmailChecked && HasMailSetting && this.state.HasEmailAddress} ref="ref_Assigned_User" onChange={this.emailChecked} /> Notify assignee
                            </p>
                        </td> 
                    </tr> : ""
                    }
                </table>
                <Form>
                    <FormGroup row style={{ "margin-bottom": "1px" }}>
                        <Col sm={{ size: 4 }}>
                            <Label className='workordermainheaderlbl'>{this.props.getDetails.WorkOrderDetails.serialNumber}</Label>
                        </Col>
                        <Col sm={{ size: 8 }}>
                            <div className="workorderbtn-cancel" onClick={this.onCancel} style={{'float': 'right', 'margin-left': '6px'}}>CANCEL</div>
                            <div className="workorderbtn-save" onClick={this.onWorkOrderUpdate} style={{'float': 'right'}}><MdSave style={{width: '15px', height: '15px', 'margin-right': '3px'}} />SAVE</div>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        {
                            (status.length > 0) ?
                                <Col sm={{ size: 2 }}>
                                    <Label className={(this.state.error.status)? classnames("errortext","workorderlbl"):"workorderlbl"}>{(status[0].required)? status[0].fieldLabel + "*" : status[0].fieldLabel}</Label><br />
                                    <select ref='status_in_Select_input' className={(this.state.error.status)? classnames("errorhighlight","minimal workorderedit-dropdown") : "minimal workorderedit-dropdown"} style={{ width: '100%' }} onChange={this.OnStatusChange} >
                                        {status_in_Select_input}
                                    </select>
                                    <span hidden={!this.state.error.status}>{selecterrortext}</span>
                                </Col> : ""
                        }
                        {
                            (assignedto.length > 0) ?
                                <Col sm={{ size: 2 }}>
                                    <Label className={(this.state.error.assignto)? classnames("errortext","workorderlbl"):"workorderlbl"}>{(assignedto[0].required)? assignedto[0].fieldLabel + "*" : assignedto[0].fieldLabel}</Label><br />
                                    <select ref='user_in_Select_input' className={(this.state.error.assignto)? classnames("errorhighlight","minimal workorderedit-dropdown") : "minimal workorderedit-dropdown"}  style={{ width: '100%' }} onChange={this.OnUserChange} >
                                        {Default_drop_down_value}
                                        {technicians_in_Select_input}
                                    </select>
                                    <span hidden={!this.state.error.assignto}>{selecterrortext}</span>
                                </Col> : ""
                        }
                        {
                            (notifyOthers.length > 0) ?
                                <Col sm={{ size: 2 }}>
                                    <Label className={(this.state.error.notifyOthers) ? classnames("errortext workorderlbl", "workorderlbl") : "workorderlbl"}>{(notifyOthers[0].required) ? notifyOthers[0].fieldLabel + "*" : notifyOthers[0].fieldLabel}</Label><br />
                                    <MultiSelectComponent id="select_notifyothers" ref='notifyothers_in_Select_input' width='100%' cssClass={(this.state.error.notifyOthers) ? classnames("arrowdown-error multiselect-dropdown", "arrowdown multiselect-dropdown") : "arrowdown multiselect-dropdown"}
                                        dataSource={notifiers_in_Select_input}
                                        fields={this.dropdown_fields}
                                        mode="CheckBox"
                                        select={this.onNotifyOthersSelect.bind(this)}
                                        removed={this.onNotifyOthersRemove.bind(this)}
                                        value={this.state.SelectedNotifyOthersIds}
                                        showSelectAll={true} enableSelectionOrder={false}
                                        filterBarPlaceholder="Search" placeholder="Select" selectAllText="Select All" unSelectAllText="Clear All" >
                                        <Inject services={[CheckBoxSelection]} />
                                    </MultiSelectComponent>
                                    <span hidden={!this.state.error.notifyOthers}>{selecterrortext}</span>
                                </Col> : ""
                        }
                        {
                            (createdby.length > 0) ?
                                <Col sm={{ size: 4 }}>
                                    <Label className="workorderlbl">{createdby[0].fieldLabel}</Label><br />
                                    <Label className="workorderheaderlbl" style={{ width: '100%' }}>{this.state.CreatedByUserName}</Label>
                                </Col> : ""
                        }
                        </FormGroup>
                        <FormGroup row>
                        {
                            (urgency.length > 0) ?
                                <Col sm={{ size: 2 }}>
                                    <Label className={(this.state.error.urgency)? classnames("errortext","workorderlbl"):"workorderlbl"} >{(urgency[0].required)? urgency[0].fieldLabel + "*" : urgency[0].fieldLabel }</Label><br />
                                    <select ref='urgencys_in_Select_input' className={(this.state.error.urgency)? classnames("errorhighlight","minimal workorderedit-dropdown") : "minimal workorderedit-dropdown"} style={{ width: '100%' }} onChange={this.OnUrgencyChange} >
                                        {Default_drop_down_value}
                                        {urgency_in_Select_input}
                                    </select>
                                    <span hidden={!this.state.error.urgency}>{selecterrortext}</span>
                                </Col> : ""
                        }
                        {
                            (dueDate.length > 0) ?
                            <Col sm={{ size: 2 }}>
                                <Label className={(this.state.error.duedate)? classnames("errortext","workorderlbl"):"workorderlbl"}>{(dueDate[0].required) ? dueDate[0].fieldLabel + "*" : dueDate[0].fieldLabel}</Label><br />
                                <div className={(this.state.error.duedate)? classnames("customDatePickerWidthError workorderheaderlbl") : "customDatePickerWidth workorderheaderlbl"}>
                                    <DatePicker
                                        customInput={<DatePickerCustom />}
                                        utcOffset={0}
                                        selected={this.state.dueDate} isClearable={false} minDate={this.state.SiteId > 0 ? this.state.BuildingDate : this.state.ServerTime}
                                        onChange={this.handleChange} showDisabledMonthNavigation
                                        dateFormat={UserFormat} />
                                </div>
                                <span hidden={!this.state.error.duedate}>{selecterrortext}</span>
                            </Col> : ""
                        }                        
                    </FormGroup>
                    <hr style={{backgroundColor:'#666666',height:'1px',border:'none'}}/>
                    <FormGroup row>
                        <Col sm={{ size: 2 }}>
                            <Label className='workordersubheaderlbl' style={{'font-weight':'bold'}}>{label['WorkOrderEdit.Details.Text'] !== undefined ? label['WorkOrderEdit.Details.Text'] : "Details"}</Label>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        {
                            (building.length > 0) ?
                                <Col sm={{ size: 2 }}>
                                    <Label className={(this.state.error.building || !IsSelectedBuildingExists)? classnames("errortext","workorderlbl"):"workorderlbl"}>{(building[0].required)? building[0].fieldLabel + "*" : building[0].fieldLabel}</Label><br />
                                    <select ref='buildings_in_Select_input' className={(this.state.error.building || !IsSelectedBuildingExists)? classnames("errorhighlight","minimal workorderedit-dropdown") : "minimal workorderedit-dropdown"} style={{ width: '100%' }} onChange={this.LoadBuildingFloors} >
                                        {Default_drop_down_value}
                                        {buildings_in_Select_input}
                                    </select>
                                    <span hidden={!this.state.error.building}>{selecterrortext}</span>
                                    <span hidden={IsSelectedBuildingExists}><Label style={{'color':'#D42D27', 'font-style':'italic','font-size':'10px','font-family':'Lato' }}><b>Selected building(s) no longer in system</b></Label></span>
                                </Col> : ""
                        }
                        {
                            (tenant.length > 0) ?
                                <Col sm={{ size: 2 }}>
                                    <Label className={(this.state.error.tenant)? classnames("errortext","workorderlbl"):"workorderlbl"}>{(tenant[0].required)? tenant[0].fieldLabel + "*": tenant[0].fieldLabel}</Label><br/>
                                    <input disabled= {this.state.disablecontrol} type="text" ref='tenants_in_Select_input' className={(this.state.error.tenant)? classnames("errorhighlight","minimal workorderedit-dropdown") : "minimal workorderedit-dropdown"} value={this.state.TenantName} style={{width:'100%'}} placeholder={label['WorkOrders.DropDown.Default.Text']} onClick={this.ComputeStyle} />
                                    <span hidden={!this.state.error.tenant}>{selecterrortext}</span>
                                </Col> : ""
                        }
                        {
                            (floor.length > 0 && space.length > 0) ?
                                <Col sm={{ size: 2 }}>
                                    <Label className={(this.state.error.space || this.state.error.floor)? classnames("errortext","workorderlbl"):"workorderlbl"} >{(floor[0].required || space[0].required) ? floor[0].fieldLabel+ ('/') + space[0].fieldLabel + "*" : floor[0].fieldLabel+ ('/') + space[0].fieldLabel }</Label><br />
                                    <input type="text" ref='Spaces_in_Select_input' className={(this.state.error.space || this.state.error.floor)? classnames("errorhighlight","minimal workorderedit-dropdown") : "minimal workorderedit-dropdown"}  value={this.state.RoomName !== "Choose one" ? this.state.RoomName : this.state.FloorName} style={{ width: '100%', height: '15' }} placeholder={label['WorkOrders.DropDown.Default.Text']} onClick={this.ComputeSpaceStyle} />
                                    <span hidden={!(this.state.error.space || this.state.error.floor)}>{selecterrortext}</span>
                                </Col> : ""
                        }
                    </FormGroup>
                    <FormGroup row>
                        {
                            (problem.length > 0) ?
                                <Col sm={{ size: 2 }}>
                                    <Label className={(this.state.error.problem)? classnames("errortext","workorderlbl"):"workorderlbl"}>{(problem[0].required) ? problem[0].fieldLabel + "*" : problem[0].fieldLabel}</Label><br />
                                    <select ref='problems_in_Select_input' className={(this.state.error.problem)? classnames("errorhighlight","minimal workorderedit-dropdown") : "minimal workorderedit-dropdown"} style={{ width: '100%' }} onChange={this.SelectProblem}>
                                        {Default_drop_down_value}
                                        {problems_in_Select_input}
                                    </select>
                                    <span hidden={!this.state.error.problem}>{selecterrortext}</span>           
                                </Col> : ""
                        }
                        {
                            (equipment.length > 0) ?
                                <Col sm={{ size: 2 }}>
                                    <Label className={(this.state.error.equip)? classnames("errortext","workorderlbl"):"workorderlbl"}>{(equipment[0].required) ? equipment[0].fieldLabel + "*" : equipment[0].fieldLabel}</Label><br />
                                    <input type="text" ref='equipments_in_Select_input' value={this.state.EquipmentName} className={(this.state.error.equip)? classnames("errorhighlight","minimal workorderedit-dropdown") : "minimal workorderedit-dropdown"} style={{width:'100%'}} placeholder={label['WorkOrders.DropDown.Default.Text']} onClick={this.ComputeEquipmentStyle} />
                                    <span hidden={!this.state.error.equip}>{selecterrortext}</span>
                                </Col> : ""
                        }
                       
                    </FormGroup>
                    {lstCustomFields}
                    <FormGroup row>
                        {
                            (description.length > 0) ?
                                <Col sm={{ size: 9 }}>
                                    <Label className={(this.state.error.description)? classnames("errortext","workorderlbl"):"workorderlbl"}>{(description[0].required) ? description[0].fieldLabel + "*" : description[0].fieldLabel}</Label><br />
                                    <textarea ref='description' className={(this.state.error.description)? classnames("errorhighlight","workorderedit-textarea workorderheaderlbl"):"workorderedit-textarea workorderheaderlbl"} value={this.state.Description} style={{width:'85%'}} onChange={evt => this.updateDescriptionValue(evt)}/>
                                    <span hidden={!this.state.error.description}><Icon name='exclamation triangle' style={ErrorSign}/><br/>
                                        <Label style={{'color':'#D42D27', 'font-style':'italic','font-size':'10px','font-family':'Lato'}}><b>An entry is required</b></Label></span>
                                </Col> : ""
                        }
                    </FormGroup>
                    <AttachmentElement WOTaskID={this.props.TaskId} />
                </Form>
                <SearchableDropDown name="tenantdropdown" refMethod={this.setWrapperRef} groupname="rdTenant" data={this.state.TenantData} selectedID={this.state.TenantId} elementStyle={this.state.TenantDropDownStyles} selectedLocation={this.state.TenantLocation} setValue={this.setTenant} />
                <SearchableEquipmentDropDown name="Equipmentdropdown" refMethod={this.setEquipmentWrapperRef} groupname="rdEquipment" data={this.state.EquipmentData}  selectedID={this.state.EquipmentId} selectedLocation={this.state.EquipmentLocation} elementStyle={this.state.EquipmentDropDownStyles} setValue={this.setEquipment} />
                <SearchableSpaceDropDown name="Spacedropdown" refMethod={this.setSpaceWrapperRef} groupname="rdSpace" data={this.state.SpacesData} selectedID={this.state.RoomId !== 0 ? this.state.RoomId : this.state.FloorId} elementStyle={this.state.SpacesDropDownStyles} setValue={this.setSpace} />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        getDetails: state.WorkorderRootReducer,
        getTenantList: state.tenantsRootReducer.TenantsList,
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getWorkOrderBuildings: state.WorkorderRootReducer.WorkorderBuildings,
        getBuildingEquipments: state.WorkorderRootReducer.BuildingsEquipments,
        getTechnicianList: state.WorkorderRootReducer.Technicians,
        UserPreference_response: state.userPreferencesRootReducer.UserPreference,
        ModalOpenCloseResponse: state.ModalOpenCloseRootReducer,
        getWorkorderPreferences: state.authService.workorder_user_preferencedetails,
        getTenantAssociations: state.WorkorderRootReducer.TenantAssociations,
        getEquipments: state.WorkorderRootReducer.WorkorderEquipments,
        getMailSetting: state.WorkorderRootReducer.MailSetting,
        EquipmentSummary: state.authService.EquipmentSummaryDetail,
        getCustomFields: state.WorkorderRootReducer.WorkOrderCustomFields
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetWorkorderDetails: (WorkOrderID) => dispatch(GetWorkorderDetails(WorkOrderID)),
        makeGetCall: () => dispatch(makeGetCall()),
        GetWorkOrderBuildings: () => dispatch(GetWorkOrderBuildings()),
        GetWorkOrderBuildingsEquipments: () => dispatch(GetWorkOrderBuildingsEquipments()),
        GetWorkorderTechnician: () => dispatch(GetWorkorderTechnician()),
        UpdateWorkOrder: (data, id) => dispatch(UpdateWorkOrder(data, id)),
        GetBuildingAssociation: (TenantId) => dispatch(GetBuildingAssociation(TenantId)),
        GetWorkOrderEquipments: () => dispatch(GetWorkOrderEquipments()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UpadteWorkOrder)